export default __webpack_public_path__ + "static/media/21.57161050.jpg";